module.exports = __webpack_public_path__ + "assets/img/ava.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/ava.png
// module id = 1986
// module chunks = 0